import UnderBanner from "../components/Home/UnderBanner/UnderBanner";
import WorkMaint from "../components/Home/WorkMaint/WorkMaint";
import WhyChoose from "../components/Home/WhyChoose/WhyChoose";
import HelmetLayout from "../components/GlobalComponents/HelmetLayout";
import Quality from "../components/Home/Quality/Quality";
import Regulations from "../components/Home/Regulations/Regulations";
import MepServices from "../components/Home/MepServices/MepServices";
import Banner from "../components/Home/Banner/Banner";

const Home = () => {
  return (
    <HelmetLayout
      name="Home"
      title="Ard Altaamir: Expert renovation & Maintenance services"
      description="Ard Altaamir delivers top-quality plumbing, electrical, mechanical, and renovation services for residential and commercial projects."
      route=""
    >
      <Banner />
      <MepServices />
      {/* <OurServices /> */}
      <UnderBanner />
      <Quality />
      {/* <OurCommitment /> */}
      <WorkMaint />
      <WhyChoose />
      <Regulations />
    </HelmetLayout>
  );
};

export default Home;
